import Content from "@/components/About Us/Content";
import HeroSection from "@/components/About Us/HeroSection";
import Navbar from "@/components/Index/Navbar";

export default function AboutUs() {
  return (
    <>
      <Navbar />
      <HeroSection />
      <Content />
    </>
  );
}
